import React, { Fragment } from 'react';
import Button from '../../UI/Button/Button';

class OrderSummary extends React.Component {
    // this could be a functional component, doesn't have to be a class

    render () {
        const ingredientSummary = Object.keys(this.props.ingredients).map(igKey => {
            return <li key={igKey}>
                <span style={{textTransform: 'capitalize'}}>{igKey}</span>: {this.props.ingredients[igKey]}
            </li>;
        });
        return (
            <Fragment >
            <h3>Your Order</h3>
            <p>A delicious burger with the following ingredients: </p>
            <ul>
                {ingredientSummary}
            </ul>
            <p><strong>Total Price: {this.props.price.toFixed(2)}</strong></p>
            <p>Continue to Checkout?</p>
            <Button btnType="Danger" clicked={this.props.purchaseCancelled} >CANCEL</Button>
            <Button btnType="Success" clicked={this.props.purchaseContinued} >CONTINUE</Button>
            
        </Fragment>
        );
    }
   
};

export default OrderSummary;


// WEBPACK FOOTER //
// ./src/components/Burger/OrderSummary/OrderSummary.jsx